import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <MediaSection />
        <CardsSection />
        <ContactSection />
        <FaqSection />
        <AboutSection />
        <CommentsSection />
        <CarouselSection />
        <AppSection />
        <TopicsSection />
        <RankingSection />
        <FeaturesSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}